import "react-datepicker/dist/react-datepicker.css";


import { useEffect, useState } from "react";
import { useLocation } from 'react-router-dom';
import WarehouseService from "../../services/WarehouseService";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import DataTableProductTransation from "../../ui/DataTableProductTransation";
import withLoader from "../../components/layouts/WithLoader";
import SellingService from "../../services/SellingService";
const ProductsTransaction = ({ startLoading, stopLoading }) => {
  const [warehouseManagers, setWarehouseManagers] = useState([]);
  const [availableProducts, setAvailableProducts] = useState([]);
  const [warehouse, setWarehouse] = useState([]);
  const [productInfo, setProductInfo] = useState([]);
  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const [ca, setCa] = useState(0);
  const [achat, setAchat] = useState(0);
  // const location = useLocation();
  // const queryParams = new URLSearchParams(location.search);
  const id = localStorage.getItem('idProduct')

  useEffect(() => {
    startLoading()
    SellingService.getProductsTransactionsAndTransferts(
      getCurrentUserId(),
      id
    )
      .then((response) => {
        console.log("response-------------->", response)
        setAvailableProducts(response.data.success);
        setProductInfo(response.data.product)
      })
      .catch((e) => {
        console.log("error", e);
      }).finally(() => {
        stopLoading()
      })
  }, []);
  const onEditWarehouseHandler = (
    idWarehouse,
    oldWarehouseName,
    oldWarehouseDesc,
    oldWarehouseReference,
    oldWarehouseManagerId
  ) => {
    let oldWarehouseData = {
      idWarehouse: idWarehouse,
      name: oldWarehouseName,
      description: oldWarehouseDesc,
      warehouseReference: oldWarehouseReference,
      warehouseManagerId: oldWarehouseManagerId,
    };
    setOldWarehouseData(oldWarehouseData);
    setOnEditWarehouse(true);
  };

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          {sessionStorage.getItem("typeDocument") === "Warehouse" && (
            <>




              <div className="row">
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray ">
                    <span className="info-box-icon">
                      <i class="fas fa-shopping-cart"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Produit</span>
                      <span className="info-box-number">
                        {productInfo?.name}
                      </span>
                    </div>
                  </div>
                </div>
                <div className="col-md-6 col-sm-6 col-12">
                  <div className="info-box bg-gray-dark">
                    <span className="info-box-icon">
                      <i className="fas fa-barcode"></i>
                    </span>
                    <div className="info-box-content">
                      <span className="info-box-text">Code-barres</span>
                      <span className="info-box-number">
                        {productInfo?.barcode}
                      </span>
                    </div>
                  </div>
                </div>

              </div>


            </>
          )}
          <div className="row ">
            <div className="col-sm-12">
              {availableProducts && (
                <DataTableProductTransation listProduits={availableProducts} />
              )}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
export default withLoader(ProductsTransaction);
